import React from 'react';
import { Check, ClipboardList, X } from 'lucide-react';

interface ContinuousScanHeroProps {
  cameraOpen?: boolean;
  code?: string;
  failure?: boolean;
  focusReady?: boolean;
  identified?: boolean;
  pillText: string;
  scannerAction?: React.ReactNode;
  subtitle: string;
  title: string;
}

function ContinuousScanHero({
  cameraOpen = false,
  code = '',
  failure = false,
  focusReady = true,
  identified = false,
  pillText,
  scannerAction,
  subtitle,
  title,
}: ContinuousScanHeroProps) {
  return (
    <section
      className={`continuous-pmi-hero${cameraOpen ? ' continuous-pmi-hero--camera-open' : ''}`}
      aria-live="polite"
    >
      <div className="continuous-pmi-orbit" aria-hidden="true">
        <span className="continuous-pmi-orbit__ring continuous-pmi-orbit__ring--outer" />
        <span className="continuous-pmi-orbit__ring continuous-pmi-orbit__ring--middle" />
        <span className="continuous-pmi-orbit__ring continuous-pmi-orbit__ring--inner" />
      </div>

      <div className="continuous-pmi-scanner">
        <span className="continuous-pmi-corner continuous-pmi-corner--tl" />
        <span className="continuous-pmi-corner continuous-pmi-corner--tr" />
        <span className="continuous-pmi-corner continuous-pmi-corner--bl" />
        <span className="continuous-pmi-corner continuous-pmi-corner--br" />
        <span className="continuous-pmi-scanline" />
        {identified ? (
          <span className="continuous-pmi-result-mark" aria-hidden="true">
            {failure ? <X size={38} /> : <Check size={40} />}
          </span>
        ) : null}
        <div className="continuous-pmi-barcode" aria-hidden="true">
          {Array.from({ length: 26 }).map((_, index) => (
            <span key={index} style={{ width: `${index % 4 === 0 ? 5 : index % 3 === 0 ? 3 : 2}px` }} />
          ))}
        </div>
        <div className="continuous-pmi-serial">{code || pillText}</div>
        {code ? (
          <div className="continuous-pmi-card-line">
            <span><ClipboardList size={18} />扫码</span>
            <strong>{code}</strong>
          </div>
        ) : null}
      </div>

      <div className="continuous-pmi-state">
        <div className="continuous-pmi-state__title">{title}</div>
        <div className="continuous-pmi-state__sub">{subtitle}</div>
        {identified ? (
          <div className="continuous-pmi-chip"><Check size={18} />已识别</div>
        ) : (
          <>
            <div className="continuous-pmi-scan-pill">
              <span aria-hidden="true" />{pillText}
            </div>
            <div className={`continuous-pmi-input-status continuous-pmi-input-status--${focusReady ? 'ready' : 'info'}`}>
              <span aria-hidden="true" />{focusReady ? '扫码焦点已锁定' : '正在处理扫码'}
            </div>
          </>
        )}
      </div>

      {scannerAction}
    </section>
  );
}

export default ContinuousScanHero;
